module.exports = __webpack_public_path__ + "static/img/bc_qt_4.4b7a7f2a.png";